import React from 'react';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import UploadButton from '../Input/UploadButton';
import { GET_PROVIDER, CLASSES_BY_SOURCETYPE } from './constants';
import withStores from '../../stores/withStores';
import useI18n from '../../i18n/useI18n';

const styles = theme => ({
  root: {
    // marginBottom: theme.spacing(4),
    width: '100%',
    '@global .capitalize': {
      textTransform: 'capitalize',
    },
  },
  wrap: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  horizontalMargin: {
    '& > *': {
      margin: props =>
        props.flexDirection === 'column'
          ? theme.spacing(1, 0)
          : theme.spacing(0, 2),
      '&:last-child': {
        marginRight: 0,
      },
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
  button: {
    margin: props =>
      props.flexDirection === 'column'
        ? theme.spacing(0, 0, 2, 0)
        : theme.spacing(0, 4, 0, 0),
  },
  embedForm: {
    display: 'flex',
    //width: '100%',
    margin: theme.spacing(0, 0, 0, 2),
    '& > *': {
      marginRight: theme.spacing(2),
      // '&:last-child': {
      //   marginRight: 0,
      // },
    },
  },
  input: {
    flexGrow: 1,
    maxWidth: 400,
  },
  inputRoot: {
    // color: props =>
    //   props.dark ? theme.palette.common.black : theme.palette.common.white,
  },
});

const initialState = {
  showEmbedForm: false,
  embedUrl: '',
  sourceType: 'unknown',
};

@withStyles(styles)
@withStores('mediaStore')
@observer
class CreationForm extends React.Component {
  state = initialState;

  handleFileUpload = async e => {
    const file = e.target.files.item(0);
    const response = await this.props.mediaStore.uploadFile(file);
    this.props.onChange(response);
  };
  handleEmbedUrlChange = e => {
    const value = e.target.value;
    this.setState({
      embedUrl: value,
      sourceType: GET_PROVIDER(value),
    });
  };
  openEmbedForm = e => {
    this.setState({
      showEmbedForm: true,
    });
  };
  handleSubmitEmbedForm = async e => {
    e.preventDefault();
    const { sourceType, embedUrl } = this.state;
    const response = await this.props.mediaStore.createMedia(
      CLASSES_BY_SOURCETYPE[sourceType],
      embedUrl,
      sourceType,
    );
    this.reset();
    this.props.onChange(response);
  };
  reset = () => {
    this.setState({
      ...initialState,
    });
  };
  get renderSourceType() {
    const { i18n } = this.props;
    const { sourceType } = this.state;
    if (sourceType === 'unknown') return i18n.t('media.create.sourceUnknown');
    return (
      <Typography variant="caption">
        {i18n.t('media.create.sourceKnown', {
          sourceType: <span className="capitalize">{sourceType}</span>,
        })}
      </Typography>
    );
  }
  render() {
    const { classes, i18n, rootProps, flexDirection } = this.props;
    const { showEmbedForm, embedUrl } = this.state;
    const isFlexDirectionColumn = flexDirection === 'column';
    return (
      <React.Fragment>
        <Box
          className={cx(classes.wrap, classes.horizontalMargin)}
          {...rootProps}
          flexDirection={flexDirection}
        >
          <Box
            display="flex"
            alignItems="center"
            flexDirection={flexDirection}
            width={isFlexDirectionColumn ? '100%' : 'auto'}
          >
            <UploadButton
              name="upload"
              variant="contained"
              className={cx(classes.button)}
              onChange={this.handleFileUpload}
              fullWidth={isFlexDirectionColumn}
            >
              {i18n.t('media.create.fileUpload')}
            </UploadButton>
            {null && (
              <Button
                variant="contained"
                className={classes.button}
                onClick={this.openEmbedForm}
              >
                {i18n.t('media.create.externalUrl')}
              </Button>
            )}
            <Typography variant="body1" color="textSecondary">
              {i18n.t('media.create.or')}
            </Typography>
          </Box>

          <TextField
            required
            type="url"
            size="small"
            variant="outlined"
            // name="embed-url"
            label={i18n.t('media.create.url')}
            value={embedUrl}
            onChange={this.handleEmbedUrlChange}
            className={classes.input}
            InputProps={{ className: classes.inputRoot }}
            placeholder="https://"
            helperText={this.renderSourceType}
          />
          <Button
            fullWidth={isFlexDirectionColumn}
            variant="contained"
            type="submit"
            onClick={this.handleSubmitEmbedForm}
          >
            {i18n.t('media.create.confirm')}
          </Button>
        </Box>
      </React.Fragment>
    );
  }
}

CreationForm.defaultProps = {
  onChange: () => {},
  variant: 'horizontal',
};

const CreationFormWithI18n = props => {
  const i18n = useI18n();
  return <CreationForm i18n={i18n} {...props} />;
};

export default CreationFormWithI18n;
